var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCamOnUserList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3913 6H1.95652C1.42825 6 1 6.42825 1 6.95652V17.4783C1 18.0065 1.42825 18.4348 1.95652 18.4348H14.3913C14.9196 18.4348 15.3478 18.0065 15.3478 17.4783V6.95652C15.3478 6.42825 14.9196 6 14.3913 6Z",
    fill: "#00D7A4",
    stroke: "#00D7A4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 16.6693C22.9999 17.041 22.6087 17.2827 22.2763 17.1165L17.5371 14.7469C17.3677 14.6622 17.2607 14.4891 17.2607 14.2997V10.1351C17.2607 9.94574 17.3677 9.77261 17.5371 9.68791L22.2763 7.31835C22.6087 7.15212 22.9999 7.39387 22.9999 7.76556V16.6693Z",
    fill: "#00D7A4",
    stroke: "#00D7A4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamOnUserList);
export default __webpack_public_path__ + "static/media/VideoCamOn-userList.86c217f6.svg";
export { ForwardRef as ReactComponent };